import Vue from 'vue';
import { mapGetters } from 'vuex';
import VueTour from 'vue-tour'
import VueHtml2Canvas from 'vue-html2canvas';
import swal from 'sweetalert'; // eslint-disable-line no-unused-vars
import 'rpg-awesome/css/rpg-awesome.min.css';
import 'vue-tour/dist/vue-tour.css';

import ItemGenerator from './components/ItemGenerator.vue';
import store from './store';
import './main.scss';

Vue.use(VueHtml2Canvas);
Vue.use(VueTour)
Vue.config.productionTip = false;

new Vue({
  store,
  computed: {
    ...mapGetters([ 'hasGeneratedItems' ])
  },
  mounted () {
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  },
  methods: {
    beforeUnloadHandler (event) {
      if (this.hasGeneratedItems) {
        const confirmationMessage = `
          Existem itens na lista!
          Sair da página pode apagar seus artefatos.
        `;

        event.returnValue = confirmationMessage;

        return confirmationMessage;
      }
    }
  },
  render: h => h(ItemGenerator)
}).$mount('#app')